



import { useState } from 'react';

const MESFunctionality = () => {
  const features = [
    { id: 'quality', label: 'Quality', position: 'top' },
    { id: 'material', label: 'Material Handling', position: 'right' },
    { id: 'maintenance', label: 'Maintenance', position: 'bottom' },
    { id: 'energy', label: 'Energy', position: 'left' },
  ];

  return (
    <div className="w-full py-16 px-4 overflow-hidden bg-gradient-to-br from-[#EFF6FF] to-[#F3F4F6]">
      <div className="max-w-6xl mx-auto space-y-12">
        {/* Top: Text + Image */}
        <div className="flex flex-col md:flex-row items-center gap-12">
          {/* Text block */}
          <div className="md:w-1/2 space-y-6">
            <h1
              className="font-extrabold leading-snug"
              style={{ fontSize: 'clamp(2rem, 5vw, 3rem)' }}
            >
              <span className="text-[#f30000] text-4xl font-bold">Infor MES</span>{' '}
              <span className="text-[#1a1a6f] text-2xl">software functionality</span>
            </h1>
            <p className="text-[#374151] text-base md:text-lg">
              Support a wide range of processes across discrete, assembly,
              process/batch manufacturing.
            </p>

            <ul className="space-y-4">
              {[
                'Manage all production, inventory, quality and maintenance operations',
                'Enable detailed inventory management and instant bi-directional traceability',
                'Low code to easily add connections to machines, lines, add assets and create visual dashboards',
              ].map((text, idx) => (
                <li key={idx} className="flex items-start">
                  <div className="flex-shrink-0 mt-1 w-6 h-6 rounded-full bg-[#2563EB] flex items-center justify-center">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="w-4 h-4 text-white"
                      fill="currentColor"
                      viewBox="0 0 20 20"
                    >
                      <path
                        fillRule="evenodd"
                        d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                        clipRule="evenodd"
                      />
                    </svg>
                  </div>
                  <p className="ml-3 text-[#374151]">{text}</p>
                </li>
              ))}
            </ul>
          </div>

          {/* Image */}
          <div className="md:w-1/2 flex justify-center">
            <img
              src="https://ik.imagekit.io/kqumni8l2/MES/MES_functionality_light.png?updatedAt=1747033304249"
              alt="Infor MES"
              className="h-80 object-contain"
            />
          </div>
        </div>

        {/* Bottom stats */}
        <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {[
            {
              iconPath:
                'M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z',
              title: 'Increased Productivity',
              desc: 'Up to 25% increase in overall manufacturing productivity',
            },
            {
              iconPath:
                'M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z',
              title: 'Real-Time Visibility',
              desc: 'Monitor production and inventory in real-time across facilities',
            },
            {
              iconPath:
                'M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z',
              title: 'Quality Assurance',
              desc: 'Reduce defects by up to 30% with integrated quality controls',
            },
            {
              iconPath:
                'M13 10V3L4 14h7v7l9-11h-7z',
              title: 'Quick Implementation',
              desc: 'Deploy and see results in a few months with low-code approach',
            },
          ].map((stat, idx) => (
            <div
              key={idx}
              className="bg-white rounded-2xl shadow p-6 transform transition-transform hover:scale-105 cursor-pointer"
            >
              <div className="w-12 h-12 bg-[#DBEAFE] rounded-lg flex items-center justify-center mb-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-6 h-6 text-[#2563EB]"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d={stat.iconPath}
                  />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-[#1E3A8A]">
                {stat.title}
              </h3>
              <p className="text-[#4B5563] mt-2">{stat.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MESFunctionality;
